import createUseStyles from '@picsart/rc/create';

const useAnchorStyles = createUseStyles(
  {
    root: {
      cursor: 'pointer',
    },
  },
  { name: 'anchor' },
);

export default useAnchorStyles;
